import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {ISingleDocument} from '../../services/utilis/ResponseObjects.types';
import RenderLocale from './RenderLocale';

interface IRenderLocalesColumnProps {
  hit: ISingleDocument
}

const RenderLocalesColumn = ({hit}: IRenderLocalesColumnProps) => {
  const [error, setError] = useState(false);
  const {t} = useTranslation();

  return (
    <>
      <div className={'locale-column-wrapper'}>
        {hit.locales.map((locale, index) => (
          <RenderLocale key={index} isin={hit.isin} type={hit.type} locale={locale} setError={setError}/>
        ))}
      </div>

      {error && <div className="locale-error">{t('errors.notFoundError')}</div>}
    </>
  )
}

export default RenderLocalesColumn
